import {clearSkillPathCache} from '../StudentSkillPath/useStudentSkillPath';
import useClassroomInvitations from '../ClassroomInvitations/hooks/useClassroomInvitations';
import useClassrooms from '../Sidebar/hooks/useClassrooms';
import useCurrentTab from './useCurrentTab';
import useIndependentPracticeSubjects from '../StudentIndependentPractice/hooks/useIndependentPracticeSubjects';

export default function useOnClassroomEnrollment(classroomId: string | undefined) {
  const currentTab = useCurrentTab();
  const {fetchClassroomInvitations} = useClassroomInvitations();
  const {fetchClassrooms} = useClassrooms();
  const {fetchIndependentPracticeSubjects} = useIndependentPracticeSubjects(classroomId);

  function onClassroomEnrollment() {
    clearSkillPathCache();
    fetchClassroomInvitations();
    fetchClassrooms();

    if (currentTab === 'independent-practice') {
      fetchIndependentPracticeSubjects();
    }
  }

  return onClassroomEnrollment;
}
